export const customOrderColumnPfx = 'col_order_';
export const qtyInputClassName = 'custom-qty-input';
export const selectedSkuImageIdPfx = 'modal-main-image';
